export const isCustomValue = (value?: string) => value !== "*-*"
